module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/sorry.46168789.png";